<template>
  <div class="alarm-icon-wrap">
    <div class="icon-wrap" :style="{ backgroundColor: color }">
      <em class="icon iconfont" :class="icon"></em>
    </div>
    <div class="state-text" :style="{ color }">{{ stateText }}</div>
  </div>
</template>

<script>
import { isObject } from '@/utils/is';

const stateDict = {
  '-1': { text: '离线', icon: 'icon-disabled', color: '#a9a9a9' },
  0: { text: '正常', icon: 'icon-normal', color: '#03b36e' },
  1: { text: '数值报警', icon: 'icon-up-arrow', color: '#ff4847' },
  2: { text: '电量报警', icon: 'icon-battery', color: '#ff4847' },
  3: { text: '故障报警', icon: 'icon-warning', color: '#ff4847' }
};

export default {
  props: {
    state: {
      type: [Number, String],
      validator(v) {
        return isObject(stateDict[v]);
      },
      default: '-1'
    }
  },
  computed: {
    stateText() {
      return stateDict[this.state].text;
    },
    icon() {
      return stateDict[this.state].icon;
    },
    color() {
      return stateDict[this.state].color;
    }
  }
};
</script>

<style lang="scss">
.alarm-icon-wrap {
  width: 65px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  .icon-wrap {
    width: 60px;
    height: 60px;
    color: #00000e;
    border-radius: 50%;
    margin-bottom: 5px;
    padding: 2px;
    text-align: center;
    line-height: 60px;
    em {
      font-size: 4em;
    }
  }
  .state-text {
    font-size: 15px;
    text-align: center;
  }
}
</style>
